import { Button, Modal, Collapse } from "antd";
import { ContainerButton, StyledButton } from "../styles";

const { Panel } = Collapse;

export default function ModalAcoes({
  isModalOpen,
  handleFechar,
  onClick,
}: any) {
  const handleButtonClick = (key: string) => {
    const params: any = { key };
    onClick(params);
  };

  const collapseItems = [
    {
      key: "1",
      label: "Mudar Situação",
      children: (
        <>
          <StyledButton onClick={() => handleButtonClick("2")}>
            Alugar
          </StyledButton>
          <StyledButton onClick={() => handleButtonClick("3")}>
            Trocar
          </StyledButton>
          <StyledButton onClick={() => handleButtonClick("4")}>
            Alugar ou Trocar
          </StyledButton>
          <StyledButton onClick={() => handleButtonClick("12")}>
            Alterar Valor
          </StyledButton>
          <StyledButton onClick={() => handleButtonClick("19")}>
            Reservado pelo Próprio
          </StyledButton>
          <StyledButton onClick={() => handleButtonClick("7")}>
            Reservado por MC
          </StyledButton>
          <StyledButton onClick={() => handleButtonClick("20")}>
            Utilizar
          </StyledButton>
        </>
      ),
    },
    {
      key: "2",
      label: "Mudar Divulgação",
      children: (
        <>
          <StyledButton onClick={() => handleButtonClick("8")}>
            Não Divulgado
          </StyledButton>
          <StyledButton onClick={() => handleButtonClick("9")}>
            Divulgado
          </StyledButton>
        </>
      ),
    },
    {
      key: "3",
      label: "Outras Ações",
      children: (
        <>
          <StyledButton onClick={() => handleButtonClick("10")}>
            Excluir
          </StyledButton>
          <StyledButton onClick={() => handleButtonClick("16")}>
            Confirmar Alterações
          </StyledButton>
          <StyledButton onClick={() => handleButtonClick("17")}>
            Valor a ser anunciado
          </StyledButton>
          <StyledButton onClick={() => handleButtonClick("18")}>
            Reserva
          </StyledButton>
        </>
      ),
    },
    {
      key: "4",
      label: "Mensagens",
      children: (
        <>
          <StyledButton onClick={() => handleButtonClick("11")}>
            Genérica
          </StyledButton>
        </>
      ),
    },
  ];

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      title="Ações Disponíveis"
      footer={null}
    >
      <ContainerButton style={{ padding: "10px" }}>
        <Collapse accordion bordered={false} items={collapseItems} />
      </ContainerButton>
    </Modal>
  );
}
